// extracted by mini-css-extract-plugin
export default {"legendColor":"Filter_legendColor__XAtW5","filter":"Filter_filter__wZMkC"};